<ng-container *ngFor="let item of templates.values(); trackBy: trackById">
    <div class="overlay-content" [attr.data-id]="item.id">
        <ng-container
            [ngComponentOutlet]="item.component"
            [ndcDynamicInputs]="item.inputs"
            [ndcDynamicOutputs]="item.outputs"
        ></ng-container>
    </div>
</ng-container>
